export const normalizeUntouchedDiscount = <T>(value: T): T | null => {
  if (typeof value !== 'object' || value === null) {
    return value;
  }
  return Object.values(value).every(
    (field) => field === null || field === undefined || field === ''
  )
    ? null
    : value;
};
